import React from 'react';
import { BrowserRouter as Router, Routes, Route, Link } from "react-router-dom";
import styles from './menu.module.scss';

const Menu: React.FC<{ open: boolean, setMenuOpen: (state: boolean) => void }> = ({ open, setMenuOpen }) => {
  const closeMenu = () => {
    setMenuOpen(false);
  }

  const links = [
    {
      link: "/",
      icon: "home",
      title: "صفحه اصلی"
    },
    {
      link: "/maquettes",
      icon: "music-alt",
      title: "تکست و ماکت"
    },
    {
      link: "/beats",
      icon: "compact-disc",
      title: "بیت"
    },
    {
      link: "/studios",
      icon: "microphone-alt",
      title: "استودیوها"
    },
    {
      link: "/artists",
      icon: "album-collection",
      title: "آرتیست ها"
    },
    {
      link: "/contact",
      icon: "envelope",
      title: "تماس با ما"
    },
    {
      link: "/terms",
      icon: "list-alt",
      title: "قوانین تکست نویس"
    },

  ];

  return (
    <div className="row">
      <div className="container">
        <nav className={styles.navbar + ' navbar'}>
          <div className={styles.navigation + " ml-auto" + (open ? ' ' + styles.open : '')}>
            <div className={styles.overlay} onClick={closeMenu} />
            <ul className="topnav">
              {links.map((link, index) => (
                <li key={link.icon + index}>
                  <Link to={link.link} onClick={closeMenu}>
                    <i className={"fa fa-" + link.icon} /> {link.title}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </nav>
      </div>
    </div>
  );
}

export default Menu;
